import * as S from './Summary.sc';

import Description from '@components/Description/Description';
import Rating from './Rating/Rating';
import Recommended from '@components/Recommended/Recommended';

export interface RatingsProps {
  build_text: string;
  build_value: string;
  display_text: string;
  display_value: string;
  play_text: string;
  play_value: string;
  recommended: boolean;
  siteTitle: string;
  vfm_text: string;
  vfm_value: string;
}

interface SummaryProps extends RatingsProps {
  section: Section;
  summary: string;
}

const Summary = ({
  build_text,
  build_value,
  display_text,
  display_value,
  play_text,
  play_value,
  recommended,
  section,
  siteTitle,
  summary,
  vfm_text,
  vfm_value,
}: SummaryProps) => {
  return (
    <S.Wrapper>
      <S.Container>
        <Description content={summary} />

        <S.Ratings>
          <Rating
            section={section}
            summary={build_text}
            title="Build"
            score={build_value}
          />
          <Rating
            section={section}
            summary={display_text}
            title="Display"
            score={display_value}
          />
          <Rating
            section={section}
            summary={play_text}
            title="Play"
            score={play_value}
          />
          <Rating
            section={section}
            summary={vfm_text}
            title="Value"
            score={vfm_value}
          />
        </S.Ratings>
        {recommended ? <Recommended siteTitle={siteTitle} /> : null}
      </S.Container>
    </S.Wrapper>
  );
};

export default Summary;
